// Page titles (v1.3 ticket 11, RCMC-07): every page names itself in the browser tab, "<Page> | RCMC RTA", so an
// Investor can tell tabs apart and a screen reader announces where they are. v1.2 showed "RCMC RTA" everywhere.
import { useEffect } from "react";
import { useMatches } from "react-router-dom";

// The portal's name: the second half of every title, and the whole of public/index.html's static fallback title
export const SITE_TITLE = "RCMC RTA";

/** Title the document "<page> | RCMC RTA" (or just "RCMC RTA" with no page) whenever `page` changes */
export function useDocumentTitle(page) {
  useEffect(() => {
    document.title = page ? `${page} | ${SITE_TITLE}` : SITE_TITLE;
  }, [page]);
}

/** Titles the document while rendered: for a screen the routes do not name, e.g. the Account Pending dialog, which
 *  shows instead of the shell. A component, not a hook in the parent: a parent's effect runs after its children's,
 *  so a hook there would overwrite the shell's title. */
export function DocumentTitle({ page }) {
  useDocumentTitle(page);
  return null;
}

/** The page name the current route declares: the deepest matched route's `handle.title` (routes.js), either text or
 *  a function of the route's params (a Service Request's page names its Request ID) */
export function useRouteTitle() {
  const declared = [...useMatches()].reverse().find((match) => match.handle?.title);
  const title = declared?.handle.title;
  return typeof title === "function" ? title(declared.params) : title;
}
